import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LocaleService } from '@career/core/services/locale.service';

@Component({
  selector: 'app-cielo-home',
  templateUrl: './cielo-home.component.html',
  styleUrls: ['./cielo-home.component.scss']
})
export class CieloHomeComponent implements OnInit {

  @Input() scope;
  resumeOrCvText = this.localeService.getResumeOrCVText();
  constructor(private localeService: LocaleService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  getSafeVideoUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
